// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a777d694","239":"4c22b8e3","455":"e8fa76e3"}[chunkId] + ".chunk.js";
};